module.exports = __webpack_public_path__ + "static/img/hotel-karosta-1.0839767.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/articles/1911262/hotel-karosta-1.jpg
// module id = W+vg
// module chunks = 1